import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { withLogBiEvent, } from '../biLogger/hocs/withLogBiEvent';
import { BiEventType, BiDataHook, BiLoggerContextProvider } from '../biLogger';
import UserAvatar from '../User/Avatar';
import LoadingIndicator from '../LoadingIndicator';
import ElementQueries from '../ElementQueries';
import { EditorFlavourConfigs } from '../DaEditorWrapper/config';
import DaEditorWrapper from '../DaEditorWrapper/LoadableDaEditorWrapper';
import { IS_EMPTY_FEATURE } from '../DaEditorWrapper/Features/isEmpty';
import mergeTheme from '../DaEditorWrapper/Themes/mergeTheme';
import LazyPlaceholder from './_partials/LazyPlaceholder';
import CommentBoxFooter from './_partials/CommentBoxFooter';
import DisabledComment from '../DisabledComment';
// Merge the text theme with the editor theme (content vs editor toolbars etc)
import commentTextTheme from '../DaEditorWrapper/Themes/Viewer/comments.scss';
import commentEditorTheme from '../DaEditorWrapper/Themes/Editor/comments.scss';
import CommentForAnonymous from '../CommentForAnonymous';
import { withVerification, } from '../VerificationPopup/withVerification';
import InView from 'react-intersection-observer';
import LoadingPlaceholder from './_partials/LoadingPlaceholder';
import { withFeatureFlags } from '../redux/flags';
import { compose } from 'redux';
import Separator from '../Separator';
import s from './CommentBox.scss';
import noop from '../utils/noop';
var editorTheme = mergeTheme(commentTextTheme, commentEditorTheme);
var CommentBox = /** @class */ (function (_super) {
    tslib_1.__extends(CommentBox, _super);
    function CommentBox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isEmpty: true,
            isEdit: false,
            isLoading: false,
            isExpanded: true,
            isFocused: false,
            footerToolbar: undefined,
            focusOnMount: false,
        };
        _this.postComment = function () {
            var _a = _this.props, id = _a.id, isBusy = _a.isBusy, editComment = _a.editComment, replyComment = _a.replyComment, commentableType = _a.commentableType, commentableItemId = _a.commentableItemId, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, onPublishComment = _a.onPublishComment, logBiEvent = _a.logBiEvent;
            if (isBusy) {
                return;
            }
            if (isVerificationNeeded) {
                pushVerificationPopup('comment');
                return;
            }
            if (!_this.state.isEdit) {
                logBiEvent({
                    evid: BiEventType.COMMENT_BUTTON_CLICK,
                    itemid: typeof commentableItemId === 'string'
                        ? parseInt(commentableItemId)
                        : commentableItemId,
                    typeid: commentableType,
                    is_reply: replyComment ? 1 : 0,
                });
            }
            onPublishComment &&
                onPublishComment({
                    editorId: id,
                    typeId: commentableType,
                    itemId: commentableItemId,
                    rawContentState: _this.editorRawState,
                    editorContent: _this.editorContent,
                    featuresData: _this.editorFeatures,
                    editComment: editComment,
                    replyComment: replyComment,
                });
        };
        _this.handlePlaceholderClick = function () {
            _this.setState({ isLoading: true });
        };
        _this.handleEditorChange = function (rawContentState, editorContent, featuresData) {
            _this.editorRawState = rawContentState;
            _this.editorContent = editorContent;
            _this.editorFeatures = featuresData;
            _this.featureChange(featuresData);
        };
        _this.handleEditorBlur = function () {
            _this.setState({ isFocused: false });
        };
        _this.expand = function () {
            var _a = _this.props, logBiEvent = _a.logBiEvent, commentableItemId = _a.commentableItemId, commentableType = _a.commentableType;
            logBiEvent({
                evid: BiEventType.CLICK_ON_COMMENTS_TO_START_TYPING,
                itemid: typeof commentableItemId === 'string'
                    ? parseInt(commentableItemId)
                    : commentableItemId,
                typeid: commentableType,
            });
            _this.setState({
                isLoading: false,
                isExpanded: true,
                isFocused: true,
            });
        };
        _this.startCollapse = function () {
            _this.timer = setTimeout(_this.collapse, 300);
        };
        _this.collapse = function () {
            if (!_this.state.isEdit && _this.state.isEmpty) {
                _this.setState({ isExpanded: false });
            }
        };
        _this.cancel = function () {
            var _a = _this.props, t = _a.t, onClose = _a.onClose;
            clearTimeout(_this.timer);
            if (!_this.state.isEdit && !_this.state.isEmpty) {
                var cancel = confirm(t('commentbox.editor.cancel.confirm'));
                if (!cancel) {
                    return;
                }
                _this.editorApi.clearEditor();
                _this.setState({ isEmpty: true });
            }
            _this.setState({ isExpanded: false });
            onClose && onClose();
        };
        _this.featureChange = function (features) {
            for (var _i = 0, features_1 = features; _i < features_1.length; _i++) {
                var feature = features_1[_i];
                if (feature.type === IS_EMPTY_FEATURE) {
                    _this.setState({ isEmpty: feature.data.isEmpty });
                }
            }
        };
        _this.handleEditorReady = function (toolbars, api) {
            _this.editorApi = api;
            if (!_this.state.footerToolbar && toolbars.FOOTER) {
                _this.setState({ footerToolbar: toolbars.FOOTER });
            }
            if (_this.props.focus) {
                _this.setState({ focusOnMount: true }); // Need to force loadable to load
                _this.props.focusDone && _this.props.focusDone(_this.props.id);
            }
            if (_this.props.onEditorReady) {
                _this.props.onEditorReady();
            }
        };
        _this.state.isEdit = props.editComment ? true : false;
        _this.state.isExpanded =
            _this.props.initiallyExpanded || _this.state.isEdit || props.focus;
        if (_this.state.isEdit && props.editComment) {
            _this.initialContent = props.editComment.textContent;
        }
        return _this;
    }
    // TODO remove this its deprecated
    CommentBox.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.publishResult) {
            !this.state.isEdit && this.editorApi.clearEditor();
            this.setState({
                isExpanded: false,
            });
        }
        if (nextProps.focus) {
            this.setState({ isExpanded: true });
        }
    };
    CommentBox.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, publishResult = _a.publishResult, onPublishSuccess = _a.onPublishSuccess, errorMsg = _a.errorMsg, onEditorChanged = _a.onEditorChanged;
        if (publishResult && prevProps.publishResult !== publishResult) {
            onPublishSuccess && onPublishSuccess(publishResult);
        }
        if ((errorMsg || publishResult) && onEditorChanged) {
            onEditorChanged({ editorId: this.props.id }); // Clear last result/error
        }
    };
    CommentBox.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, user = _a.user, className = _a.className, isBusy = _a.isBusy, isError = _a.isError, isLoggedIn = _a.isLoggedIn, tabIndexBase = _a.tabIndexBase, focus = _a.focus, replyComment = _a.replyComment, canPostComment = _a.canPostComment, editorClassName = _a.editorClassName, editorWrapperClassName = _a.editorWrapperClassName, footerClassName = _a.footerClassName, flags = _a.flags, commentableItemId = _a.commentableItemId, commentableType = _a.commentableType;
        var _b = this.state, isLoading = _b.isLoading, isExpanded = _b.isExpanded, isFocused = _b.isFocused, isEmpty = _b.isEmpty, isEdit = _b.isEdit, focusOnMount = _b.focusOnMount;
        // We always want to focus because the lazy placeholder click wants
        // focus right away, but we allow that to be overridden
        var shouldFocus = focus !== false || focusOnMount;
        // Force load the editor on mount when we have content or focus request
        // focus is a little complex here, focus is requested by redux action
        // and then set to false when done, we therefore have to also have some state
        // that forces the mount/load on next render,
        var forceLoadOnMount = !!this.initialContent || replyComment || focus || focusOnMount;
        var shouldUseUpdatedStyles = flags.includes('redesigned_comment_box_panel');
        return (React.createElement(ElementQueries, { id: this.props.id, className: classnames('no-theme-skin', s['commentbox'], className, (isExpanded || isLoading) && s['expanded']), widthBreakpoints: [490] }, !canPostComment && isLoggedIn ? (React.createElement(DisabledComment, { title: t('Comments are disabled') })) : (React.createElement(React.Fragment, null,
            React.createElement(UserAvatar, { user: user, className: s['commentbox-avatar'], withLink: isLoggedIn }),
            React.createElement("div", { className: classnames(s['commentbox-content'], shouldUseUpdatedStyles && s['updated-styles-for-panel-changes'], 'da-editor-comment') }, isLoggedIn ? (React.createElement(InView, { triggerOnce: true, threshold: 1, onChange: function (inView) {
                    // This is here is handle animations that scroll to the editor
                    if (inView && shouldFocus && _this.editorApi) {
                        _this.editorApi.focusEditor();
                    }
                } }, function (_a) {
                var inView = _a.inView, ref = _a.ref;
                return (React.createElement("div", { ref: ref, className: classnames(s['commentbox-editor-wrapper'], editorWrapperClassName, isFocused && s['focused']), "data-hook": BiDataHook.COMMENT_EDITOR },
                    isError && _this.renderError(),
                    isBusy && React.createElement(LoadingIndicator, { className: s['loading'] }),
                    React.createElement(DaEditorWrapper, { staticComponent: LazyPlaceholder, onStaticComponentClick: _this.handlePlaceholderClick, loadingComponent: LoadingPlaceholder, forceLoadOnMount: forceLoadOnMount, flavour: EditorFlavourConfigs.COMMENT, editorKey: _this.props.id, theme: editorTheme, onEditorInit: _this.handleEditorReady, initialContent: _this.initialContent || undefined, placeholder: t('commentbox.editor.placeholder'), "aria-label": _this.props['aria-label'], "aria-labelledby": _this.props['aria-labelledby'], onFocus: _this.expand, onBlur: _this.handleEditorBlur, onContentChange: _this.handleEditorChange, onKeyboardSubmit: _this.postComment, tabIndex: tabIndexBase || 0 + 1, filterPaste: true, autoFocus: inView && shouldFocus, className: classnames(s['commentbox-editor'], editorClassName) }),
                    shouldUseUpdatedStyles && (React.createElement(Separator, { className: s['separator'] })),
                    isExpanded && (React.createElement(BiLoggerContextProvider, { value: {
                            itemid: typeof commentableItemId === 'string'
                                ? parseInt(commentableItemId)
                                : commentableItemId,
                            typeid: commentableType,
                        } },
                        React.createElement(CommentBoxFooter, { toolbar: _this.state.footerToolbar, isEditorBusy: isBusy || false, isEditorEmpty: isEmpty, isEdit: isEdit, onCancel: _this.cancel, onSubmit: _this.postComment, tabIndexBase: tabIndexBase, compact: _this.props.compact, className: classnames(s['commentbox-footer'], footerClassName) })))));
            })) : (React.createElement(CommentForAnonymous, null)))))));
    };
    CommentBox.prototype.renderError = function () {
        // TODO get designers to make nice errors
        if (this.props.errorMsg) {
            alert(this.props.errorMsg);
        }
    };
    CommentBox.defaultProps = {
        tabIndexBase: 0,
        canPostComment: true,
        onEditorReady: noop,
    };
    return CommentBox;
}(React.PureComponent));
export { CommentBox };
var enhance = compose(withLogBiEvent, withVerification, withFeatureFlags, withTranslation());
export default enhance(CommentBox);
//# sourceMappingURL=CommentBox.js.map